import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { IModuleBalances } from '../../api/interfaces'
import { IChart, IChartConfig } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

export async function getRuneBondingAPRConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_module_balances', timeframe)) as IModuleBalances[]
	const series1 = chartData.map((element: IModuleBalances) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.RUNE_BONDING_7D_APR_PCT }
	})
	const series2 = chartData.map((element: IModuleBalances) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.RUNE_BONDING_30D_APR_PCT }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: '7d APR',
			type: 'line',
			seriesGroup: '[%]',
			color: 'green',
			unitSymbol: '%'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: '30d APR',
			type: 'line',
			seriesGroup: '[%]',
			color: 'orange',
			unitSymbol: '%'
		}
	]
	return { config: config, latestValue: series1[series1.length - 1].y, latestValueDate: series1[series1.length - 1].x }
}

const RuneBondingAPR = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getRuneBondingAPRConfig)

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Rune Bonding APR"
			chartDesc="Current annual percentage rate for Rune bonding. For each day average total bonded balance and average yield from last 7 or 30 days is calculated, divided and multiplied by 365 to extrapolate yearly earning percentage."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="7a055efe-72db-4ee0-b542-d4fa0541c84d"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
		/>
	)
}

export default RuneBondingAPR
